<!-- Desktop: TieredMenu popup -->
<p-tieredMenu #userActions [model]="items" [popup]="true" [appendTo]="'body'" />

<div
  class="clickable-avatar"
  style="cursor: pointer; display: inline-flex; align-items: center; gap: 0.5rem; position: relative"
  (click)="isMobile ? onAvatarClick($event) : userActions.toggle($event)"
>
  <div class="user-info">
    <div class="user-name">{{ userName }}</div>
    <div class="user-email" *ngIf="userEmail">{{ userEmail }}</div>
  </div>
  <div style="position: relative">
    <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" shape="circle" styleClass="ml-2" />
  </div>
</div>

<!-- Mobile: Drawer desde abajo -->
<p-drawer
  [(visible)]="drawerVisible"
  position="bottom"
  [modal]="true"
  [styleClass]="'user-actions-drawer'"
  [style]="{ height: 'auto', 'max-height': '70vh', 'border-radius': '1rem 1rem 0 0' }"
>
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <p-avatar image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" shape="circle" size="large" />
      <div class="drawer-user-info">
        <div class="drawer-user-name">{{ userName }}</div>
        <div class="drawer-user-email">{{ userEmail }}</div>
      </div>
    </div>
  </ng-template>

  <div class="drawer-menu">
    <div class="drawer-menu-item" (click)="onProfileClick()">
      <i class="pi pi-user"></i>
      <span>Mi perfil</span>
    </div>

    <div class="drawer-divider"></div>

    <div class="drawer-menu-item" (click)="showThemeSubmenu = !showThemeSubmenu">
      <i class="pi pi-palette"></i>
      <span>Tema</span>
      <i class="pi ml-auto" [ngClass]="showThemeSubmenu ? 'pi-chevron-up' : 'pi-chevron-down'" style="font-size: 0.75rem"></i>
    </div>
    <div class="drawer-submenu" *ngIf="showThemeSubmenu">
      <div class="drawer-menu-item sub" (click)="setTheme('light')">
        <i class="pi pi-sun"></i>
        <span>Modo Claro</span>
      </div>
      <div class="drawer-menu-item sub" (click)="setTheme('dark')">
        <i class="pi pi-moon"></i>
        <span>Modo Oscuro</span>
      </div>
      <div class="drawer-menu-item sub" (click)="setTheme('system')">
        <i class="pi pi-desktop"></i>
        <span>Sistema</span>
      </div>
    </div>

    <div class="drawer-divider"></div>

    <div class="drawer-menu-item logout" (click)="onLogoutClick(); drawerVisible = false">
      <i class="pi pi-sign-out"></i>
      <span>Cerrar sesión</span>
    </div>
  </div>
</p-drawer>
